import { MenuOptions } from '../../models/kt';

export const defaultMenuOptions: MenuOptions = {
   dropdown: {
      hoverTimeout: 200,
      zindex: 105,
   },
   accordion: {
      slideSpeed: 250,
      expand: false,
   },
}


